import treatmentLogo from './images/treatmentLogo.png';
import caraCalm from './images/caraCalm.png';
import caraWow from './images/caraWow.png';
import checkboxOrangeChecked from './images/checkboxOrangeChecked.png';
export {treatmentLogo, checkboxOrangeChecked, caraCalm, caraWow};
